// Date helpers for the range calendar in AssignInvitationCodeDialog. Dates are
// handled as local YYYY-MM-DD strings so comparisons are plain string compares.

export function startOfMonth(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), 1)
}

export function shiftMonth(date: Date, delta: number): Date {
    return new Date(date.getFullYear(), date.getMonth() + delta, 1)
}

export function toIsoDate(date: Date): string {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}

// Week starts on Monday, so the leading blanks are (weekday + 6) % 7.
export function monthCells(month: Date): (string | null)[] {
    const lead = (new Date(month.getFullYear(), month.getMonth(), 1).getDay() + 6) % 7
    const total = new Date(month.getFullYear(), month.getMonth() + 1, 0).getDate()
    const cells: (string | null)[] = Array.from({length: lead}, () => null)
    for (let day = 1; day <= total; day++) cells.push(toIsoDate(new Date(month.getFullYear(), month.getMonth(), day)))
    return cells
}

export function weekdayInitials(locale: string): string[] {
    const formatter = new Intl.DateTimeFormat(locale, {weekday: 'narrow'})
    // 2024-01-01 was a Monday — walk a known week so the labels follow the grid.
    return Array.from({length: 7}, (_, i) => formatter.format(new Date(2024, 0, 1 + i)).toUpperCase())
}

export function formatDay(isoDate: string, locale: string): string {
    if (!isoDate) return ''
    const [year, month, day] = isoDate.split('-').map(Number)
    return new Date(year, month - 1, day).toLocaleDateString(locale, {day: '2-digit', month: 'short', year: 'numeric'})
}

export function stripScheme(url: string): string {
    return url.replace(/^https?:\/\//, '')
}
